var exports = {
  "lm": "ThreadComposerArea.module__notice___ZGFkT1",
  "EP": "ThreadComposerArea.module__noticeIcon___ZGFkT1",
  "ut": "ThreadComposerArea.module__noticeText___ZGFkT1",
  "Sx": "ThreadComposerArea.module__lockedIcon___ZGFkT1",
};

module.exports = exports;
